import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AlunoCard } from "../../shared/components/aluno-card/aluno-card";
import { AlunoMatriculaCardComponent } from "../../shared/components/aluno-matricula-card/aluno-matricula-card";
import { MatriculaService } from '../../services/matricula.service';
import { PreMatriculaService } from '../../services/pre-matricula.service';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Banner } from '../../shared/components/banner/banner';
import { DemonstrativoQuitacao } from '../../shared/models/demonstrativo-quitacao.model';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, AlunoCard, AlunoMatriculaCardComponent, MatIconModule, MatProgressSpinnerModule, Banner],
  templateUrl: './home.html',
  styleUrl: './home.scss'
})
export class Home implements OnInit {
  listaMatriculas: any[] = [];
  listaCardsReMatriculas: any[] = [];
  matriculas: any[] = [];
  preMatriculas: any[] = [];
  preMatriculasAux: any[] = [];
  anoLetivoPreMatricula: any;
  alunosProcessoFinalizadoEPagoOuPendente: any[] = [];

  alunosIds: number[] | null = null;

  dados: DemonstrativoQuitacao = new DemonstrativoQuitacao();

  constructor(
    private matriculaService: MatriculaService,
    private preMatriculaService: PreMatriculaService,
    private _snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.buscarTodosAlunos();
    this.dados.anoBase = 2025;
    this.dados.clienteId = 0;
    this.dados.EmpresasIds = [0];
  }


  ordenaAlunos() {
    this.matriculas = this.matriculas.sort((a, b) => {
      if ((a.matriculaTipoDescricao === 'Pre-Matricula') !== (b.matriculaTipoDescricao === 'Pre-Matricula')) {
        return a.matriculaTipoDescricao === 'Pre-Matricula' ? -1 : 1;
      }

      const anoA = parseInt(a.matricula.anoLetivo.dataInicio.slice(0, 4), 10);
      const anoB = parseInt(b.matricula.anoLetivo.dataInicio.slice(0, 4), 10);
      if (anoA !== anoB) return anoB - anoA;

      const statusOrder: any = { 'Ativo': 0, 'Inativo': 1 };
      return statusOrder[a.status] - statusOrder[b.status];
    });
  }

  buscarTodosAlunos() {
    this.listaCardsReMatriculas = [];
    let matriculasAux: any[] = [];

    this.matriculaService.buscarMatriculas(true).subscribe(data => {
      this.listaMatriculas = data.body;

      // ======= SETA alunosIds pro banner =======
      this.alunosIds = Array.from(
        new Set(this.listaMatriculas.map(aluno => aluno.matricula?.alunoId).filter(Boolean))
      );

      const alunosIdsUnicos = [...this.alunosIds];

      this.preMatriculaService.buscarAlunosPreMatriculas(alunosIdsUnicos).subscribe(preMatriculasData => {
        this.preMatriculas = preMatriculasData.body || [];
        this.preMatriculasAux = [...this.preMatriculas];

        this.preMatriculaService.VerificaAnoLetivoPreMatricula(alunosIdsUnicos).subscribe(verificaAnoLetivoData => {
          this.anoLetivoPreMatricula = verificaAnoLetivoData.body?.preMatriculaAnoLetivo ?? null;
          this.alunosProcessoFinalizadoEPagoOuPendente = verificaAnoLetivoData.body?.preMatriculaAlunos ?? [];

          this.matriculas = this.listaMatriculas.map(matriculaAluno => {

            const mostraPreMatricula = (this.preMatriculas.some((pm: any) => {
              return pm.alunoId === matriculaAluno.alunoId
            }));

            const mostraCardPontilhado = (
              (matriculaAluno.matricula.anoLetivo.anoLetivoId !== verificaAnoLetivoData.body?.anoLetivoId) &&
              this.verificaSeAlunoPreMatriculaEmDia(matriculaAluno.alunoId) &&
              (!this.listaCardsReMatriculas.some((al: any) => al.alunoId === matriculaAluno.alunoId) &&
              (!this.listaMatriculas.some((m: any) => m.alunoId === matriculaAluno.alunoId && m.matricula.anoLetivo.anoLetivoId === verificaAnoLetivoData.body?.anoLetivoId)) &&
              (mostraPreMatricula === false))
            );

            if ((mostraCardPontilhado === true) && (verificaAnoLetivoData.body && verificaAnoLetivoData.body.preMatriculaAnoLetivo !== null)) {
              if (!this.listaCardsReMatriculas.some(card => card.alunoId === matriculaAluno.alunoId)) {
                this.listaCardsReMatriculas.push({
                  nomeAluno: matriculaAluno.nomeAluno,
                  alunoId: matriculaAluno.alunoId,
                  anoLetivoId: verificaAnoLetivoData.body?.anoLetivoId,
                  anoLetivoPreMatricula:
                    verificaAnoLetivoData.body?.preMatriculaAnoLetivo.descricao ?? '',
                });
              }
            }

            if (mostraPreMatricula === true) {
              const index = this.preMatriculas.findIndex((pm: any) => pm.alunoId === matriculaAluno.alunoId);
              if (index !== -1) {
                const preMatricula = this.preMatriculas[index];
                this.preMatriculas.splice(index, 1);
                matriculasAux.push(preMatricula);
              }
            }

            return { ...matriculaAluno };
          });

          this.ordenaAlunos();
          this.matriculas.unshift(...matriculasAux);
          this.conferePreMatriculas();
        });
      });
    });
  }

  conferePreMatriculas() {
    this.preMatriculasAux.forEach(preMatricula => {
      if (preMatricula.preMatriculaStatus === 2 &&
        (preMatricula.contaStatus === "Pendente" || preMatricula.contaStatus === "Atrasado" || preMatricula.contaStatus === "Erro") &&
        !this.listaCardsReMatriculas.some(card => card.alunoId === preMatricula.alunoId)) {
        this.listaCardsReMatriculas.push({
          nomeAluno: preMatricula.nomeAluno,
          alunoId: preMatricula.alunoId,
          anoLetivoId: this.anoLetivoPreMatricula?.anoLetivoId,
          anoLetivoPreMatricula: this.anoLetivoPreMatricula?.descricao ?? '',
        });
      }
    });
  }

  verificaSeAlunoPreMatriculaEmDia(alunoId: any) {
    if (this.alunosProcessoFinalizadoEPagoOuPendente?.length > 0) {
      return !this.alunosProcessoFinalizadoEPagoOuPendente.some((pm: any) => pm.alunoId === alunoId);
    } else {
      return true;
    }
  }

  baixarDemonstrativo(dados: DemonstrativoQuitacao) {
    
  }

}